// extracted by mini-css-extract-plugin
export default {"bgImage":"BackgroundProfile_bgImage__sCmQT","grayLayer":"BackgroundProfile_grayLayer__yz7hn"};